import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
    getBlockedData,
    updateUserStatus
} from "services/redux/sales/preSalesSupply/action";

import PerformanceTracker from "./performanceTracker";

const mapStateToProps = (state) => ({
    blockedUserData: state.getDropDownReducer.blockedUserData,
    updateBlockedUser: state.getDropDownReducer.updateBlockedUser,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
        getBlockedData,
        updateUserStatus
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(PerformanceTracker);
